import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=c06b9d08&scoped=true"
import script from "./UserBanner.vue?vue&type=script&lang=js"
export * from "./UserBanner.vue?vue&type=script&lang=js"
import style0 from "./UserBanner.vue?vue&type=style&index=0&id=c06b9d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06b9d08",
  null
  
)

export default component.exports